// Data de sincronismo do app (lib/config/app_version.dart → pairedUpdateLabel).
// Só muda quando o app é atualizado. Atualização só da plataforma não mexe aqui.
// Quando o app mudar, esta data tem de ser a mesma.
export const PAIRED_UPDATE_DATE = "02/11/2026";
export const PAIRED_UPDATE_LABEL = "App " + PAIRED_UPDATE_DATE;

export const PAIRED_UPDATE_CLICKS = 5;
export const PAIRED_UPDATE_GAP_MS = 8000;

export function clickHitsTarget(x, y, rect, pad = 16) {
  if (!rect) return false;
  return (
    x >= rect.left - pad &&
    x <= rect.right + pad &&
    y >= rect.top - pad &&
    y <= rect.bottom + pad
  );
}

export function nextPairedUpdateClicks(
  previous,
  nowMs,
  lastMs,
  needed = PAIRED_UPDATE_CLICKS,
  gapMs = PAIRED_UPDATE_GAP_MS
) {
  const restarted = lastMs != null && nowMs - lastMs > gapMs;
  const count = restarted ? 1 : previous + 1;
  if (count >= needed) {
    return { count: 0, revealed: true };
  }
  return { count, revealed: false };
}
